//include 28
jQuery(function () {

    var instance;
    var fallbackUrl = window.ppsettings.imageFallback;

    var conventionAnfrageEndpoint = window.pixelpoint.utilities.getAjaxUrl("/index.php?type=1732176051&action=conventionInquiry");

    //for now we use the same template
    var templateMapping = {
        poi: "poi",
        event: "poi",
        accomodation: "poi"
    };

    var tabTranslations = {
        poi: window.ppt.translate("headline.offers.plural","Angebote"),
        pois: window.ppt.translate("headline.offers.plural","Angebote"),
        event: window.ppt.translate("headline.events","Veranstaltungen"),
        eventdate: window.ppt.translate("headline.events","Veranstaltungen"),
        page: window.ppt.translate("merkliste.article","Artikel"),
        kiju: window.ppt.translate("merkliste.kiju","Kinder- und Jugendunterkünfte"),
        familypass: window.ppt.translate("merkliste.familypass","Familienpass-Angebote"),
        tour: window.ppt.translate("merkliste.tour","Touren"),
        accomodation: window.ppt.translate("merkliste.accomodation","Unterkünfte"),
        package: window.ppt.translate("merkliste.package","Arrangements"),
        convention: window.ppt.translate("merkliste.convention","Tagungen")
    };

    var privateFunctions = {
        translateTab(tab) {
            var toLowerTab = tab.toLowerCase();
            if (!!tabTranslations[toLowerTab])
                return tabTranslations[toLowerTab];
            else
                return tab;
        },
        reinitTabs(element) {
            var tabs = element.find("#bookmark-tabs");
            var tabsContent = element.find(".tabs-content");
            tabs.foundation('destroy');
            tabsContent.find(".tabs-panel").each(function () {
                var elementsCount = $(this).find("div.item").length;
                if (elementsCount == 0) {
                    var id = $(this).attr("id");
                    tabs.find(`a[href='#${id}']`).closest(".tabs-title").remove();
                    $(this).remove();
                }
            });

            if (tabsContent.find(".tabs-panel").length == 0) {
                instance.close();
                return;
            }

            var elem = new Foundation.Tabs(tabs);
            privateFunctions.bindAnfrageButton(element);
            var id = tabsContent.find(".tabs-panel").first().attr("id");
            elem.selectTab(`#${id}`);
            if(!$(`#${id}`).hasClass("is-active"))
                $(`#${id}`).addClass("is-active");
            tabs.find(".tabs-title").removeAttr("style");
            //tabs.foundation('_openTab', id);
            var sliderElement = element.find('.tabgallery .tabs-panel.is-active > .tabgallery-slider');
            $(".lity-content").css({
                width: $(".lity-content").width(),
                height: $(".lity-content").height(),
            });
            setTimeout(function () {
                if (!sliderElement.hasClass('slick-initialized')) {
                    privateFunctions.initSlickOnTabGallery(element, id);
                }
                $(".lity-content").css({
                    width: '',
                    height: '',
                });
            }, 1);
            return elem;
        },
        prepareItems(items) {
            if (!items)
                return {};
            var groups = {};
            _.each(items, function (item, itemId) {
                if (!!item.group) {
                    var translation = privateFunctions.translateTab(item.group);                    
                    if (!groups[translation]) {
                        groups[translation] = {
                            name: translation,
                            escapedName: item.group,
                            showAnfrage: false,
                            items: []
                        };
                    }
                    if(item.group == "convention"){
                        groups[translation].showAnfrage = true;
                    }
                    if (!item.id)
                        item.id = itemId;

                    var idAndType = item.id.split("_");
                    if (idAndType.length > 1) {
                        item.realId = idAndType[1];
                    } else {
                        item.realId = 0;
                    }

                    //we merge the region and location
                    item.data.locationregion = "";
                    if(!!item.data.location)
                       item.data.locationregion = item.data.location;
                    if(!!item.data.region){
                        if(!item.data.locationregion)
                            item.data.locationregion = item.data.region;
                        else if(item.data.locationregion != item.data.region)
                            item.data.locationregion += `, ${item.data.region}`;
                    } 

                    groups[translation].items.push(item);
                }
            });

            for(var i in groups){
                var jsonData = _.map(groups[i].items, (item) => {
                    return {
                        id: item.realId,
                        name: item.data.title
                    };
                });
                groups[i].jsonData = JSON.stringify(jsonData);
            }

            return groups;
        },
        render() {
            var items = window.pixelpoint.merkliste.getAll();
            if (!items)
                return "";
            var template = $("script#merkliste-template").html();
            if (!template)
                return "";

            var groups = privateFunctions.prepareItems(items);
            if (!groups)
                return "";
            var compiled = _.template(template, {
                imports: {
                    "_": _
                }
            });

            var compiledPartials = {};

            var parentClassName = "large-6";
            if(Object.keys(groups).length > 3){
               parentClassName = "large-12"; 
            }

            var firstName = Object.keys(groups)[0];
            var showAnfrage = groups[firstName].showAnfrage == true;

            let templateValues = {
                groups: groups,
                firstGroupName: firstName,
                parentClassName: parentClassName, 
                showAnfrage: showAnfrage,
                helpers: {
                    partial: function (item, template) {
                        if (!compiledPartials[template]) {
                            var usedTemplate = template;
                            if (!!templateMapping[template])
                                usedTemplate = templateMapping[template];
                            var partialTemplate = $(`script#merkliste-${usedTemplate}-template`).html();
                            if (!!partialTemplate) {
                                compiledPartials[template] = _.template(partialTemplate, {
                                    imports: {
                                        "_": _
                                    }
                                });
                            }
                        }
                        if (!!compiledPartials[template]) {
                            var result = compiledPartials[template]({
                                item: item
                            });
                            if(typeof result !== "string"){
                                result = result({
                                    item: item
                                });                                
                            }
                            return result;
                        } else {
                            return "";
                        }
                    }
                }
            };

            let result = compiled(templateValues);
            if(typeof result !== "string")
                result = result(templateValues);
            return result;
        },
        initSlickOnTabGallery(element, tabId) {
            if (!tabId) {
                tabId = '.tabs-panel.is-active';
            }
            else if(tabId.charAt(0) != "#"){
                tabId = "#" + tabId;
            }


            var options = {
                    initialSlide: 1,
                    centerMode: true,
                    //centerPadding: '-15px',
                    centerPadding: '-20px',
                    //centerPadding: '0',
                    infinite: true,
                    slidesToShow: 4,
                    slidesToScroll: 1
                },
                options1100 = {
                    //arrows: false,
                    centerMode: true,
                    //centerPadding: '25px',
                    //centerPadding: '0',
                    slidesToShow: 4,
                    //initialSlide: 2
                    initialSlide: 1
                },
                options800 = {
                    //arrows: false,
                    centerMode: true,
                    //centerPadding: '25px',
                    centerPadding: '-5px',
                    slidesToShow: 2,
                    initialSlide: 1
                },
                options600 = {
                    //arrows: false,
                    centerMode: true,
                    //centerPadding: '20px',
                    centerPadding: '-5px',
                    slidesToShow: 1,
                    initialSlide: 1
                },
                options400 = {
                    //arrows: false,
                    centerMode: true,
                    //centerPadding: '10px',
                    centerPadding: '0',
                    slidesToShow: 1,
                    initialSlide: 1
                };

            var slidesCount = element.find('.tabgallery ' + tabId + " > .tabgallery-slider > .item").length;

            if (slidesCount <= 4) {

                options.initialSlide = 0;
                options.centerMode = false;
                options.centerPadding = 0;
                options.infinite = false;
                options1100.initialSlide = 0;
                options1100.centerMode = false;
                options1100.centerPadding = 0;
                options1100.infinite = false;

                if (slidesCount <= 3) {
                    options800.initialSlide = 0;
                    options800.centerMode = false;
                    options800.centerPadding = 0;
                    options800.infinite = false;
                }
                if (slidesCount <= 2) {
                    options600.initialSlide = 0;
                    options600.centerMode = false;
                    options600.centerPadding = 0;
                    options600.infinite = false;
                }
                if (slidesCount == 1) {
                    options400.initialSlide = 0;
                    options400.centerMode = false;
                    options400.centerPadding = 0;
                    options400.infinite = false;
                }
            }

            var mainSettings = {
                slide: ".item",
                swipeToSlide: true,
                prevArrow: '<button class="prev"><i class="icon-arrow-big-left"></i></button>',
                nextArrow: '<button class="next"><i class="icon-arrow-big-right"></i></button>',
            };

            mainSettings = $.extend(mainSettings, options);

            mainSettings.responsive = [{
                    breakpoint: 1100,
                    settings: options1100
                },
                {
                    breakpoint: 800,
                    settings: options800
                },
                {
                    breakpoint: 600,
                    settings: options600
                },
                {
                    breakpoint: 400,
                    settings: options400
                }
            ];

            var determineHeight = function () {
                let maxHeight = 0;
                element.find(`.tabgallery ul .search-result-item-content`).each(function () {
                    $(this).css('height', '');
                });
                setTimeout(() => {

                    var firstSliderElement = element.find(`.tabgallery .tabs-panel.is-active div.search-result-item`).first();
                    var elementWidth = 300;
                    if(firstSliderElement.length > 0)
                    {
                        if(firstSliderElement.width() > 0)
                            elementWidth = firstSliderElement.width();
                    }

                    element.find(`.tabgallery .tabs-panel`).each((index, panel) => {
                        if(!$(panel).hasClass('is-active')){
                             $(panel).addClass('is-active remove-after');
                             $(panel).find("div.search-result-item").each((i,li)=>{
                                 if(!$(li).is('[style*="width"]') || $(li).width() == 0){
                                    $(li).css({'width': `${elementWidth}px`});
                                 }
                             });
                        }
                    });

                    element.find(`.tabgallery ul .search-result-item-content`).each(function () {
                        $(this).css('height', '');
                        let height = $(this).height();
                        if (height > maxHeight)
                            maxHeight = height;
                    });

                    element.find(`.tabgallery .tabs-panel`).each((index, panel) => {
                        if($(panel).hasClass('remove-after')){
                             $(panel).removeClass('is-active').removeClass('remove-after');
                        }
                    });

                    element.find(`.tabgallery ul .search-result-item-content`).each(function () {
                        $(this).height(maxHeight);
                    });

                },100);
            };
           
            element.find('.tabgallery ' + tabId + ' > .tabgallery-slider').off("init.determineHeight").on("init.determineHeight", determineHeight);
            
            var resizeTimeout = null;
            $(window).off("orientationchange.determineHeight resize.determineHeight").on("orientationchange.determineHeight resize.determineHeight", () => {
                if(resizeTimeout != null)
                    clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(() => {
                    determineHeight();
                    resizeTimeout = null;
                },50);
            });

            element.find('.tabgallery ' + tabId + ' > .tabgallery-slider').each((index,el) => {
                if(!$(el).hasClass('slick-initialized'))
                    $(el).slick(mainSettings);
                else{
                    if(!!el.slick && !!el.slick.refresh)
                        el.slick.refresh();
                }
            });          
            //********************************************************
            //********************************************************
        },
        bindAnfrageButton(tabs) {
            tabs.off('change.zf.tabs').on('change.zf.tabs',function(e, tab){
                if(!!tab.data("anfrage")){
                    tabs.find(".tools .anfrage").removeClass("hide");
                }
                else{
                    tabs.find(".tools .anfrage").addClass("hide");
                }
            });
        },
        initializeComponents(element) {
            var elem = new Foundation.Tabs(element.find("#bookmark-tabs"));

            privateFunctions.bindAnfrageButton(element);

            element.find('#bookmark-tabs .tabs-title').each(function(){
                var $this = $(this);

                setTimeout(function () {
                    $this.children('a:first').css("width","100%");
                }, 10);
            });

            element.find('#bookmark-tabs .tabs-title').click(function (e) {
                e.preventDefault();
                var id = $(this).children('a:first').attr('href');
                if(!$(`.tabgallery .tabs-panel${id}`).hasClass('.is-active')){
                    $(`.tabgallery .tabs-panel${id}`).addClass('is-active');
                }
                var sliderElement = element.find('.tabgallery .tabs-panel.is-active > .tabgallery-slider');
                $(".lity-content").css({
                    width: $(".lity-content").width(),
                    height: $(".lity-content").height(),
                });
                setTimeout(function () {
                    if (sliderElement.hasClass('slick-initialized')) {
                        privateFunctions.initSlickOnTabGallery(element, id);
                    }
                    $(".lity-content").css({
                        width: '',
                        height: '',
                    });
                }, 1);
            });
            //*/
            privateFunctions.initSlickOnTabGallery(element);

            element.on("click", ".removeBookmark", function () {
                var slide = $(this).closest(".search-result-item");
                if (slide.length == 0)
                    return;
                var slider = slide.closest(".tabgallery-slider.slick-initialized");
                if (slider.length == 0)
                    return;

                var bookmarkId = slide.data("bookmark-item-id");
                var slideIndex = slide.data("slide-index");
                window.pixelpoint.merkliste.remove(bookmarkId);

                var itemData = slide.closest("#bookmark-modal").find(".tabs-title.is-active").data("items");

                // TPBB-1108
                //if(typeof(bookmarkId) == 'string' && bookmarkId.indexOf("_") >= 0){
                    var parts = bookmarkId.split("_");
                    if(parts.length >= 2){
                        itemData = _.filter(itemData, item => {
                            return item.id != parts[1];
                        });
                        slide.closest("#bookmark-modal").find(".tabs-title.is-active").data("items", itemData);
                    }
                /*}
                else {
                    itemData = _.filter(itemData, item => {
                        return item.id != bookmarkId;
                    });
                    slide.closest("#bookmark-modal").find(".tabs-title.is-active").data("items", itemData);
                }*/

                //slider.slick('slickRemove', slideIndex);
                slider.slick('unslick');
                element.find(`[data-bookmark-item-id='${bookmarkId}']`).remove();

                var tab = slider.closest(".tabs-panel");
                var remainingSlidesCount = tab.find("[data-bookmark-item-id]").length;
                if (remainingSlidesCount == 0) {
                    elem = privateFunctions.reinitTabs(element);
                } else {
                    privateFunctions.initSlickOnTabGallery(element);
                }
            });

            window.pixelpoint.images.initializeErrors(element);

            element.find(".tools .print").on("click", function () {
                privateFunctions.print();
            });
            element.find(".tools .anfrage").on("click", function () {
                privateFunctions.anfrage();
            });
        },
        open() {
            var html = privateFunctions.render();
            if (!html)
                return;
            instance = lity(html);
            var element = instance.element();
            //element.find(".lity-close").attr("title", "Fenster schließen").tooltipster();
            element.find(".lity-close").attr("title", "Fenster schließen");
            element.addClass("bookmark-lity");

            privateFunctions.initializeComponents(element);
        },        
        anfrage(){
            var modal = $("#bookmark-modal");
            var itemData = modal.find(".tabs-title.is-active").data("items");
            var allProviders = _.map(itemData, item => {
                return item.name;
            }).join(", ");

            var data = {
                allProviders: allProviders,
                items: itemData
            };
            var template = $("script#merkliste-convention-provider").html();
            var compiled = _.template(template, {
                imports: {
                    "_": _
                }
            });
            let h = compiled(data);
            if(typeof h !== "string")
                h = h(data);
            var formInstance = lity(h);
            var element = formInstance.element();
            var form = element.find("form");
            new Foundation.Abide(form, {});
            var elementsToEqualize = element.find("[data-equalizer]");
            new Foundation.Equalizer(elementsToEqualize, {});
            var loader = element.find(".loader");
            if(loader.length > 0){
                window.pixelpoint.ppComponents.loader(loader);
            }
            var calendar = element.find(".calendar");
            if(calendar.length > 0) {
                window.pixelpoint.ppComponents.calendar(calendar);
            }            
            form.on("submit", function(e){
                e.preventDefault();
                privateFunctions.submitAnfrage(form, formInstance);
            });
            element.find(".checkbox-helper").each(function(e){
                var container = $(this);
                var label = container.find("label");
                var checkboxId = label.attr("for");
                label.attr("for","");
                label.addClass("clickable");
                var onClickFunc = _.debounce(function(){
                    container.find(`#${checkboxId}`).prop("checked", !container.find(`#${checkboxId}`).prop("checked"));
                },200);
                container.on("click touchstart","label",function(){
                    onClickFunc();
                });
            });
        },
        submitAnfrage: (form, formInstance) => {
            form.foundation('validateForm');
            var element = formInstance.element();
            if (form.hasClass("valid")) {
                var dataToBeSent = form.serialize();
                var loaderFunctions = element.find(".loader").data("exposed");
                if (!!loaderFunctions.show) {
                    loaderFunctions.show();
                }
                $.ajax({
                    url: conventionAnfrageEndpoint,
                    type: "POST",
                    data: dataToBeSent
                })
                .done(function(data){
                    formInstance.close();
                    lity("#merkliste-anfrage-reply-success");
                })
                .fail(function(e){
                    formInstance.close();
                    lity("#merkliste-anfrage-reply-fail");
                })
                .always(function(){
                    if (!!loaderFunctions.hide) {
                        loaderFunctions.hide();
                    }
                })
            }
        },
        print() {
            var prtContent = privateFunctions.render();
            var content = $(prtContent);
            content.addClass("for-print");
            var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
            var styles = $(`link[rel="stylesheet"]`);
            WinPrint.document.write('<html><head>');
            styles.each(function () {
                var clone = $(this).clone();
                clone.attr("href", clone[0].href); //we need the absolute url                
                WinPrint.document.write(clone[0].outerHTML);
            });
            WinPrint.document.write('</head><body>');
            var imagesLoaded = [];
            content.find(".center-cropped").each(function () {
                var img = $(this).find("img");
                var $this = $(this);
                if (img.length > 0) {
                    var src = img[0].src;

                    //we check if the image exists
                    var deferred = $.Deferred();
                    imagesLoaded.push(deferred.promise());
                    var image = new Image();

                    image.onload = function () {

                        let width = image.width;
                        let height = image.height;

                        if ((width / height) >= (298 / 180)) {
                            img.addClass('wide-img');
                        } else {
                            img.addClass('tall-img');
                        }

                        img.attr("src", src);
                        $(this).attr('style', `background-image:url("${src}");`);
                        deferred.resolve();
                    }
                    image.onerror = function () {
                        img.attr("src", fallbackUrl);
                        $(this).attr('style', `background-image:url("${fallbackUrl}");`);
                        deferred.resolve();
                    }
                    image.src = src;
                    // ---------------------------
                }
            });
            var site = window.location.hostname;//"www.reiseland-brandenburg.de";

            var title = window.ppt.translate('merkliste.print.title','Ihre Merkliste von '+site,[site]);
            content.find("h2.capital-blue").text(title);

            content.find("#bookmark-tabs .tabs-title a").each(function () {
                var target = $(this).attr("href");
                var title = $(this).text();
                content.find(target).before(`<h2 class="capital-blue page-break">${title}</h2>`);
            });

            content.find(".content-header a").each(function () {
                let href = this.href;
                if (!!href && href != "#") {
                    let title = href.replace("http://", "Link: ");
                    title = title.replace("https://", "Link: ");
                    $(`<a class="print-link" href="${href}">${title}</a>`).insertAfter($(this).closest(".search-result-item-content").find(".content-footer"));
                }
            });

            $.when.apply($, imagesLoaded).then(function () {
                WinPrint.document.write(content[0].outerHTML);
                WinPrint.document.write('</body></html>');

                setTimeout(function () {
                    $(WinPrint.document).find(".tabs-panel").each(function () {
                        let maxHeight = 0;
                        $(this).find(`.search-result-item-content`).each(function () {
                            let height = $(this).height();
                            if (height > maxHeight)
                                maxHeight = height;
                        });
                        $(this).find(`.search-result-item-content`).each(function () {
                            $(this).height(maxHeight);
                        });
                    });
                    WinPrint.document.close();
                    WinPrint.focus();
                    setTimeout(function () {
                        WinPrint.print();
                        if (!window.keepPrintOpen)
                            WinPrint.close();
                    }, 200);
                    //WinPrint.close();
                }, 200);
            });
        }
    }

    //$(".header-wrapper .header .controls .control.icon-star-after,#offCanvas .controls .control.icon-star-after").on("click", function (e) {

    /*
   .header-wrapper .header .controls .control.icon-star-after,
   .header-wrapper .header .controls .control .icon-star,
   #offCanvas .controls .control.icon-star-after,
   #offCanvas .controls .control .icon-star
   */

    $(".header-wrapper .header .controls .control.control-merkliste, #offCanvas .controls .control.control-merkliste").on("click touchstart", function (e) {
        e.stopPropagation();
        e.preventDefault();

        //$('*').tooltipster('hide');
        //$('.tooltipster-show').css("z-index", "0!important");

        var itemCount = window.pixelpoint.merkliste.count();
        if (itemCount == 0)
            return;
        privateFunctions.open();
    });

});